import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
    name: 'CmgChipotleUJoinRewardsPromptModal'
})

export default class CmgChipotleUJoinRewardsPromptModal extends Vue {
    get visible(): boolean {
        return this.$appStore.state.ui.modals.chipotleUJoinRewardsPromptModal.visible;
    }

    get args() {
        return this.$appStore.state.ui.modals.chipotleUJoinRewardsPromptModal.args;
    }

    async onJoinRewardsClick(): Promise<void> {
        if(this.args && this.args.onJoinRewards){
            await this.args.onJoinRewards();
            this.close();
        }
        this.close();
    }

    async onContinueWithoutJoiningClick(): Promise<void> {
        if(this.args && this.args.onContinueWithoutJoining){
            await this.args.onContinueWithoutJoining();
        }
        this.close();
    }

    close() {
        this.$services.ui.setModalVisibility('chipotleUJoinRewardsPromptModal', false);
    }

    get rewardTermsUrl(): string {
        return "https://www.chipotle.com/rewards-terms"
    }

    get privacyPolicyUrl(): string {
        return "https://www.chipotle.com/privacy-policy"
    }
}
